import axios from 'axios'

export default {
    namespaced: true,
    state: {
        chains: []
    },
    getters: {
        GET_SELECT_LIST(state) {
            return state.chains.map((item) => {
                return {text: item.name, value: item.id}
            })
        }
    },
    mutations: {
        FETCH_CHAINS(state, chains) {
            state.chains = chains
        },
        EDIT_CHAIN(state, chain) {
            const index = state.chains.findIndex(
                item => item.id === chain.id
            )
            if (index !== -1) {
                Object.assign(state.chains[index], chain)
            }
        },
        ADD_CHAIN(state, chain) {
            state.chains.push(chain)
        },
        DEL_CHAIN(state, id) {
            const index = state.chains.findIndex(
                item => item.id === id
            )
            if (index !== -1) {
                state.chains.splice(index, 1)
            }
        },
    },
    actions: {
        fetch({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.post(
                '/api/root/hotel-chain/list', filter
            ).then(({data}) => {
                commit('FETCH_CHAINS', data.data)
            }).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        edit({dispatch, commit}, editedItem) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/hotel-chain/edit/' + editedItem.id,
                    editedItem
                ).then(() => {
                    commit('EDIT_CHAIN', editedItem)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        add({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/hotel-chain/add',
                    data
                ).then(() => {
                    commit('ADD_CHAIN', data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({dispatch, commit}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/hotel-chain/dell/' + itemId
                ).then(() => {
                    commit('DEL_CHAIN', itemId)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}

